module.exports = __webpack_public_path__ + "img/limited.ffc75c53.svg";